import { lazy } from 'react';
// import Teste from '../../Test/pages/teste';

const MyArea = lazy(() => import('../pages'));

export const MyAreaRoutes = [
  {
    path: '/',
    element: <MyArea />,
  },
  {
    path: '/minha-area',
    element: <MyArea />,
  },
];
